import React, { useState } from "react";

import { approveJoinRequestAPI, declineJoinRequestAPI } from "utils/organization/api";
import { readApiResponse } from "utils/api";

import Button from "components/Button";

import classes from "./style.module.scss";

// Requests land on the organization document as { [uid]: name } when someone picks the organization
// at sign up. Until they are approved the requester is not a member and has no access to anything.
const JoinRequests = ({ requests = {}, uid, orgId, fetchUserOrganization, setAlert }) => {
    const [pending, setPending] = useState("");

    const requestList = Object.entries(requests);

    if (!requestList.length) return null;

    const respond = async (userId, name, approve) => {
        setPending(userId);

        const { status, message } = readApiResponse(
            approve
                ? await approveJoinRequestAPI({ uid, orgId, userId })
                : await declineJoinRequestAPI({ uid, orgId, userId })
        );

        if (status !== 200) {
            console.error("Error responding to a join request:", message);
        }

        setAlert({
            open: true,
            message:
                status !== 200
                    ? message || "Could not respond to this request. Please try again."
                    : approve
                      ? `${name} joined the organization`
                      : `Request from ${name} declined`,
            anchorOrigin: { vertical: "top", horizontal: "center" },
            direction: "down",
            severity: status !== 200 ? "error" : "success",
        });

        await fetchUserOrganization();

        setPending("");
    };

    return (
        <div className={classes.requests}>
            <h3>
                Requests to Join <span className={classes.count}>{requestList.length}</span>
            </h3>
            <ul>
                {requestList.map(([userId, name]) => (
                    <li key={userId}>
                        <span className={classes.name}>{name}</span>
                        <div className={classes.actions}>
                            <Button
                                type="hollow"
                                small
                                disabled={!!pending}
                                onClick={() => respond(userId, name, false)}
                            >
                                {pending === userId ? "Working..." : "Decline"}
                            </Button>
                            <Button small disabled={!!pending} onClick={() => respond(userId, name, true)}>
                                {pending === userId ? "Working..." : "Approve"}
                            </Button>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default JoinRequests;
